// Libraries
import React, {useEffect, useState} from 'react';
import {Link} from 'gatsby';
import {StaticImage} from 'gatsby-plugin-image';
import {useTranslation} from 'react-i18next';
import classNames from 'classnames';
// Components
import Container from '@Components/Container/Container';
import NavbarItem, {NavbarItemProps} from './NavbarItem';
// Hooks
import useWindowScroll from '@Hooks/useWindowScroll';
// Types
import {Tag} from '@Types/tags';
// Styles
import * as styles from './Navbar.module.scss';
import {AnchorLink} from 'gatsby-plugin-anchor-links';

const Navbar = () => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [isScrolled, setisScrolled] = useState(false);
	const scrollY = useWindowScroll();
	const {t} = useTranslation();

	const toggleExpandHandler = () => setIsExpanded(!isExpanded);

	const menuItems: NavbarItemProps[] = [
		{
			text: t('routes.benefits.text'),
			link: t('routes.benefits.link'),
			toggleExpandHandler,
		},
		{
			text: t('routes.about.text'),
			link: t('routes.about.link'),
			toggleExpandHandler,
		},
		{
			text: t('routes.process.text'),
			link: t('routes.process.link'),
			toggleExpandHandler,
		},
	];

	const menuLanguages: NavbarItemProps[] = [];

	useEffect(() => {
		setisScrolled(scrollY > 50);
	}, [scrollY]);

	return (
		<Container
			as={Tag.Nav}
			classes={classNames(styles.navbar, {
				[styles.navbarExpanded]: isExpanded,
				[styles.navbarScrolled]: isScrolled,
			})}>
			<AnchorLink
				to={t('routes.home.link')}
				className={styles.navbarLogo}
				onAnchorLinkClick={() => setIsExpanded(false)}>
				<StaticImage src='../../../assets/images/logo.png' alt='mbm energy' />
			</AnchorLink>
			<button
				onClick={toggleExpandHandler}
				className={styles.navbarButton}
				aria-label='menu'>
				<span></span>
				<span></span>
			</button>
			<ol className={styles.navbarMenu}>
				{menuItems.map((item) => (
					<NavbarItem key={item.text} {...item} />
				))}
				<li className={styles.navbarMenuService}>
					<NavbarItem
						as='span'
						text={t('routes.contact.text')}
						link={t('routes.contact.link')}
						isHiglited='basic'
						toggleExpandHandler={toggleExpandHandler}
					/>
					{/* <span className={styles.languages}>
						{menuLanguages.map((item) => (
							<NavbarItem as='span' key={item.text} {...item} />
						))}
					</span> */}
				</li>
			</ol>
		</Container>
	);
};

export default Navbar;
